export interface InespayResult
{
    status: string;
    url: string;
    description: string;
    idInespay?: string;
    idDebt?: string;
}

export const parseInespayResult = (dataInespay: any): InespayResult | null =>
{
    if(!dataInespay || typeof dataInespay !== 'object' || dataInespay.status === undefined)
    {
        return null;
    }

    return dataInespay;
}

export const isInespaySuccess = (result: InespayResult | null): boolean => !!result && String(result.status) === '200';
